import { SubscriptionPlan } from 'app/models/subscrition-plan.model';

export enum SubscriptionOrigins {
  Web = 'web',
  Ios = 'ios',
  Android = 'android',
}

export interface FamilyOption {
  id: number;
  endDate: Date | null;
  isAutoRenewed: boolean;
  members: ReadonlyArray<string>;
  externalAdminEmail: string | null;
}

export interface KinoSubscription {
  id: number;
  plan: SubscriptionPlan;
  startDate: Date;
  endDate: Date;
  isAutoRenewed: boolean;
  familyOption: FamilyOption | null;
  origin: SubscriptionOrigins;
}
